export const ROUTE_HOME = '/';
export const ROUTE_LOGIN = '/login';
export const ROUTE_OTP = '/login/otp';
export const ROUTE_REGISTER = '/login/register';

export const ROUTE_OFFERS = '/offers/:code';
export const ROUTE_PROMOCODES = '/promocodes';
export const ROUTE_PROMOCODES_VIEW = '/promocodes/:id';
export const ROUTE_CATEGORIES = '/categories';
export const ROUTE_CATEGORY_VIEW = '/categories/:code/:id';
export const ROUTE_FAVORITES = '/favorites';
export const ROUTE_OFFER = '/offers/offer/:id';
export const ROUTE_PROFILE = '/profile';

export const ROUTE_PROFILE_UPDATE = '/profile/update';
export const ROUTE_PROFILE_DELETE_ACCOUNT = '/profile/delete-account';
export const ROUTE_SAVED = '/saved';
export const ROUTE_CONTACT = '/contact';
